<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="!enableLoader">

<div class=" container mw-100 group-company-div visible-xs ">
    <nav class="navbar navbar-expand-lg navtext visible-flex-xs transparent p-0">
        <a [routerLink]="'/inventory/inventorymanagement' | cxUrl"  class="navbar-brand"><img src="/images/BHP_white.svg" alt="customlogo" width="57.65px" height="22px"></a>
        <a class="navbar-brand"><img src="/images/right_arrow.svg" alt="customlogo" width="24px" height="24px"></a>
    <span class="position-absolute group-company-dropdown text-white "><b>Inventory Management</b></span>
   
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="nav-item dropdown position-absolute d-flex align-items-center" style="right:0">
        <span class="text-white bold">{{loginData.userId}}</span>
      <span name='account' class=" nav-link nav-border rounded-0 dropbtn" role="button" id="navbarDropdown3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="fas fa-user-circle icon-style ipad-orientation fa-2x"></i></span>
      <div class="dropdown-menu account-dropdown mobdrop dropdown-content" aria-labelledby="navbarDropdown" >
       <!-- <h5 (click)="goToUpdatePersonalDetails()" [routerLink]="['profile/my-account/update-personal-details']"><a class="anchor-tag strong">Update Personal details</a></h5>
       <hr>
       <h5 (click)="goToResetPassword()" [routerLink]="['profile/my-account/change-password']" ><a class="anchor-tag strong">Reset Password</a></h5>
       <hr> -->
       <h5><a class="anchor-tag strong" (click)="inventorylogout()">Logout</a></h5>
      </div>
</div>
    </div>
    
</nav>
</div>
<!--mobile header-->
<div class='hidden-xs container mobile-inv'>
	<div class="hidden-xs-inv   navtext mobile-view-div d-flex justify-content-between">
		<div class="bhp-mobile"> 
      <a [routerLink]="'/inventory/inventorymanagement' | cxUrl" class="navbar-brand"><img src="/images/BHP_white.svg" alt="customlogo"><img src="/images/right_arrow.svg" alt="customlogo" ><span class=" group-company-dropdown mobile-management text-white "><b>Inventory Management</b>
      </span></a>
</div>
<div class="nav-item dropdown inline-flex nav-icon-mobile-view">
    <span name='ipadaccount' class=" user-account-icon-btn " id="navbarDropdown5" role="button" aria-haspopup="true" aria-expanded="false" (click)="showUserProfile=!showUserProfile">
      <i class="fas fa-user-circle icon-style-mobile ipad-orientation fa-2x fa-mobile-icon"></i>
                </span>
              </div>
	</div>
</div>
<!-- profile div mobile -->
<div *ngIf="showUserProfile" class="hidden-xs  navbar-dark bg-dark navtext user-Profile border-dark">
    <!-- <h5 (click)="showUserProfile=!showUserProfile" (click)='goToUpdatePersonalDetails()' [routerLink]="['profile/my-account/update-personal-details']">Update personal details</h5>
    <hr>
    <h5 (click)="showUserProfile=!showUserProfile" (click)='goToResetPassword()' [routerLink]="['profile/my-account/change-password']">Reset password
    </h5>
    <hr> -->
    <h5 (click)="showUserProfile=!showUserProfile"><a class="anchor-tag strong" (click)="inventorylogout()">Logout</a></h5>
  </div>
<!--Header-->
<div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
    <div class="container">
    <a class="strong  text-primary " [routerLink]="['/inventory/inventorymanagement']">< Back to list</a>
</div>
</div>
<!-- <hr class="mb-0"> -->
<div class="py-4 border-bottom" style="background: #F8F9FA;">
    <div class="container">
    <div class="block-xs" style="justify-content:space-between;">
        <div class="mb-3">
            <!-- <div class="p-1 border-radius-05" style="font-size:12px;background: #663366;color: white;display: inline-block;" [ngClass]="inventoryProductData && inventoryProductData.headerColor">{{inventoryProductData && inventoryProductData.shortDescription ? inventoryProductData.shortDescription : inventoryProductData.baseProductCode}}</div> -->
            <div class="p-1 border-radius-05" style="font-size:12px;background: #663366;color: white;display: inline-block;" [ngStyle]="{'background-color': inventoryProductData && inventoryProductData.headerColor}">{{inventoryProductData && inventoryProductData.baseProductCode}}</div>
            <div class="fs-24 strong pb- mt-2">
                <div class="mb-0 fw-bold inventory-heading">{{inventoryProductData && inventoryProductData.baseProduct}}</div>

                <div class="h5 mb-0 inventory-1">{{inventoryProductData && inventoryProductData.portName}}</div>
            </div>
        </div>
        <div style="display: flex;" >
            <button class="btn btn-primary mb-3" (click)="updatePricePopup()" *ngIf="inventoryProductData && inventoryProductData.status === 'approved'">Update price</button>
            <button class="btn btn-light ml-3 mb-3" (click)="unpublishBatch()" *ngIf="inventoryProductData && inventoryProductData.status === 'approved'">Unpublish batch</button>
            <button class="btn btn-primary mb-3" (click)="publishBatch()" *ngIf="inventoryProductData && inventoryProductData.status === 'check'">Publish batch</button>
            <button class="btn btn-primary mb-3" (click)="publishBatch()" *ngIf="inventoryProductData && inventoryProductData.status === 'unapproved'">Publish batch</button>
        </div>
    </div>
    <div class=" d-flex pb-0 header-property">
        <div class="mr-4 mb-3">
            <div class="small text-secondary1 ">Listing Price</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.price && inventoryProductData.price.formattedValue || '0' }} </div>
        </div>
        <div class="mr-4  mb-3">
            <div class="small text-secondary1">In Negotiation</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.negotiationQty || '0' | number :"1.0"}} </div>
        </div>
        <div class="mr-4 mb-3 ">
            <div class="small text-secondary1">Available Stock</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.availableQty || '0' | number :"1.0"}} </div>
        </div>
        <div class="mr-4 mb-3 ">
            <div class="small text-secondary1">Stock Issued</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.stockIssued || '0' | number :"1.0"}} </div>
        </div>
        <div class="mr-4 mb-3 ">
            <div class="small text-secondary1">Stock Sold</div>
            <div class="strong1">{{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.soldQty || '0' | number :"1.0"}} </div>
        </div>
        <div class="mr-4 mb-3 ">
            <div class="small text-secondary1">Collected</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.collectedQty || '0' | number :"1.0"}} </div>
        </div>
        <div class="mr-4 mb-3 ">
            <div class="small text-secondary1">To Pick Up</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.toPickUp || '0' | number :"1.0"}} </div>
        </div>
        <div class=" mb-3">
            <div class="small text-secondary1">Tradable Balance</div>
            <div class="strong1"> {{inventoryProductData && inventoryProductData.stockMetrics && inventoryProductData.stockMetrics.balanceQty || '0' | number :"1.0"}} </div>
        </div>
    </div>
</div>
</div>
<!--Header End-->

<!--Inventory Details-->
<div class="py-5 container">
    <div class="row">
     <div class="col-lg-9 overflow-hidden">
            <!-- <div class="row pl-3">
                <div class="col-lg-7 tabDiv">
                    <nav class="product-tab">
                        <div class="nav nav-tabs nav-fill pe-auto" id="nav-tab" role="tablist">
                            <div class="nav-item nav-link active tab-bar strong " id="nav-home-tab" data-toggle="tab"
                                href="#nav-by-port" role="tab" aria-controls="nav-home" aria-selected="true"
                                (click)="changeTab('active')">{{ 'inventory.productHeader.negotiation' | cxTranslate }}<span class="number">{{inventoryProductData && inventoryProductData.bids_offers && inventoryProductData.bids_offers.negotiation}}</span>
                            </div>
                            <div class="nav-item nav-link tab-bar strong " id="nav-profile-tab" data-toggle="tab"
                                href="#nav-by-product" role="tab" aria-controls="nav-profile" aria-selected="false"
                                (click)="changeTab('completed')">{{ 'inventory.productHeader.accepted' | cxTranslate }}<span class="number">{{inventoryProductData && inventoryProductData.bids_offers && inventoryProductData.bids_offers.accepted}}</span>
                            </div>
                            <div class="nav-item nav-link tab-bar strong " id="nav-contact-tab" data-toggle="tab"
                                href="#nav-all" role="tab" (click)="changeTab('archived')" aria-controls="nav-contact"
                                aria-selected="false"><span class="visible-xs">{{ 'inventory.productHeader.archive' |
                                    cxTranslate }}</span> <span class="hidden-xs">{{ 'inventory.productHeader.All' |
                                    cxTranslate }}</span> </div>
                        </div>
                    </nav>
                </div>
                <div class="mobdisplay gird-div pt-4 display-top visible-xs-filter-bar ml-auto mr-3" >
                    <span *ngIf="true" class="grid-icon css-sort ">{{ 'inventory.productHeader.sortBy' | cxTranslate }} :

                        <select class="dropdownClass" (change)="selectChangeHandler($event)">
                            <option value="listing-price">Listing Price</option>
                            <option value="in-negotiation">In Negotiation</option>
                            <option value="initial-stock">Initial Stock</option>
                            <option value="stock-sold">Stock Sold</option>
                            <option value="collected">Collected</option>
                            <option value="to-pick-up">To pick up</option>
                            <option value="tradable-balance">Tradable Balance</option>
                        </select>
                    </span>
                </div>
            </div> -->
            <div class="project-tab">

                <nav class=" desktop-inline" id="tabs">
                    <div class="nav nav-tabs nav-fill d-flex justify-content-between" id="nav-tab" role="tablist">
                        <div>
                            <a class="nav-item nav-link text-dark nav-align active strong" [class.active]="activeTab === 'active'"
                                id="nav-active-tab" data-toggle="tab" href="#nav-by-active" role="tab" aria-controls="nav-home"
                                aria-selected="true" (click)="changeTab('active')">
                                In Negotiation
                                <span class="number">{{inventoryProductData && inventoryProductData.bids_offers &&inventoryProductData.bids_offers.negotiation}}</span>
                            </a>
                        </div>
                        <div>
                            <a class="nav-item nav-link text-dark nav-align strong" [class.active]="activeTab === 'completed'" 
                                id="nav-accepted-tab" data-toggle="tab" href="#nav-by-completed" role="tab" aria-controls="nav-profile" 
                                aria-selected="false" (click)="changeTab('completed')">
                                Accepted Offers
                                <span class="number">{{inventoryProductData && inventoryProductData.bids_offers && inventoryProductData.bids_offers.accepted}}</span>
                            </a>
                        </div>
                        <div><a class="nav-item nav-link text-dark nav-align strong" [class.active]="activeTab === 'archived'"
                                id="nav-archived-tab" data-toggle="tab" href="#nav-by-completed" role="tab" aria-controls="nav-profile"
                                aria-selected="false" (click)="changeTab('archived')">
                                Archived
                            </a>
                        </div>
                        <div>
                            <a class="nav-item nav-link text-dark nav-align strong" [class.active]="activeTab === 'Nomination'" 
                                id="nav-nomination-tab" data-toggle="tab" href="#nav-by-completed" role="tab" aria-controls="nav-profile" 
                                aria-selected="false" (click)="changeTab('Nomination')">
                                Nomination
                            </a>
                        </div>
                    </div>
                     <div class="visible-xs-1020">
                        <div *ngIf="this.activeTab !== 'Nomination'" class="grid-icon css-sort visible-xs-1020 ml-auto">Sort by :
                            <select class="dropdownClass" (change)="selectChangeHandler($event)">
                                <option value="time:desc">Creation date (Descending)</option>
                                <option value="time:asc">Creation date (Ascending)</option>
                            </select>
                        </div>
                    </div> 
                </nav>
                
            </div>
           
            <hr>
            <div class="hidden-xs-1020 d-flex justify-content-center m-3">
                <div *ngIf="true" class="grid-icon css-sort hidden-xs-1020">Sort by :
                    <select class="dropdownClass" (change)="selectChangeHandler($event)">
                        <option value="time:desc">Creation date (Descending)</option>
                        <option value="time:asc">Creation date (Ascending)</option>
                    </select>
                </div>
            </div>
            <!--content area-->
            <div *ngIf="otherLoader" id="loader"></div>
            <div *ngIf="!otherLoader" >
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" role="tabpanel">
                        <div *ngIf="inventoryTab=='active'">
                            <app-custom-inventory-details-content [Data]='negotiationData' [tabName]='inventoryTab'></app-custom-inventory-details-content>
                        </div>
                        <div *ngIf="inventoryTab=='completed'">
                            <app-custom-inventory-details-content [Data]='acceptedOffersData' [tabName]='inventoryTab'></app-custom-inventory-details-content>
                        </div>
                        <div *ngIf="inventoryTab=='archived'">
                            <app-custom-inventory-details-content [Data]='archivedData' [tabName]='inventoryTab'></app-custom-inventory-details-content>
                        </div>
                        <div *ngIf="inventoryTab=='Nomination'">
                            <app-custom-inventory-details-content [Data]='nominationData' [tabName]='inventoryTab'></app-custom-inventory-details-content>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="mb-5">
            <div class="small text-secondary mt-2"><span>Batch ID</span></div>
            <div class="strong small"><span>{{inventoryProductData && inventoryProductData.batchId}}</span></div>
            <div class="small text-secondary mt-2"><span>Batch Creation Date:</span></div>
            <div class="strong small"><span>{{ inventoryProductData && convertDateOnly(inventoryProductData.creationDate)}}</span></div>
            <div class="small text-secondary mt-2"><span>Batch Status</span></div>
            <div class="badge rounded-pill bg-secondary text-white" *ngIf="inventoryProductData && inventoryProductData.status === 'check'"><span>Unpublished</span></div>
            <div class="badge rounded-pill bg-primary text-white" *ngIf="inventoryProductData && inventoryProductData.status === 'approved'"><span>Published</span></div>
            <div class="badge rounded-pill bg-secondary text-white" *ngIf="inventoryProductData && inventoryProductData.status !== 'approved' && inventoryProductData.status !== 'check'"><span>Archived</span></div>
            <div class="small text-secondary mt-2"><span>Vessel name:</span></div>
            <div class="strong small"><span>{{inventoryProductData.vesselName}}</span></div>
            </div>
            <div class="mb-5">
                <div *ngFor='let feature of featuresData' class="d-flex justify-content-between">
                    <div class="small text-secondary">{{feature && feature.key}}</div><br>
                    <div class="strong small">{{feature && feature.value}} %</div>
                </div>
            </div>
            <!-- <div class="small mt-lg-1"><span>Fe (%)(Iron content)</span><span class="float-end bold float-lg-end">62.12%</span></div>
            <div class="small mt-lg-1"><span>Iron DTU per Wet TO</span><span class="float-end bold float-lg-end">5562.12%</span></div>
            <div class="small mt-lg-1"><span>P (%)(Phosphorus)</span><span class="float-end bold float-lg-end">3.12%</span></div>
            <div class="small mt-lg-1"><span>H20 (%)(Iron content)</span><span class="float-end bold float-lg-end">8.7%</span></div>
            <div class="small mt-lg-1"><span>AI203 (%)(Alumina)</span><span class="float-end bold float-lg-end">3.7%</span></div>
            <div class="small mt-lg-1"><span>S (%)(Sulphur)</span><span class="float-end bold float-lg-end">3.12%</span></div>
            <div class="small mt-lg-1"><span>Iron wet %</span><span class="float-end bold float-lg-end">55%</span></div>
            <div class="small mt-lg-1"><span>LOI (%)(Loss in ignition)</span><span class="float-end bold float-lg-end">3.7%</span></div>
            <div class="small mt-lg-1"><span>Si02 (%)(Phosphorus)</span><span class="float-end bold float-lg-end">1.2%</span></div> -->
        </div>
    </div>
</div>
</div>